import createStore from "./createStore";
import { whiteLabelService } from "../services/whiteLabels";

const store = createStore(window.__INITIAL_STATE__);

whiteLabelService.subscribeStore(store);
export default store;
